/* ===================================================================
   collection-filters.js
   Katalogin Shopify Storefront -filtterit — AJAX + event-delegaatio.
   Delegaatio = kuuntelijat kiinnitetään kerran document/root-tasolle,
   joten ne selviävät kaikista innerHTML-vaihdoista ilman uudelleensidontaa.
   - checkbox/radio → heti AJAX
   - hintakenttä: Enter TAI Käytä-nappi → AJAX (EI sivun reloadia)
   - lajittelu, aktiivisten X-linkit, Tyhjennä → AJAX
   - mobiilidrawer: avaa/sulje
   - Lataa lisää: liittää seuraavan sivun (säilyttää filtterit)
   Osittainen päivitys Section Rendering APIlla (?section_id=), URL pushState.
   =================================================================== */
(function(){
  var root = document.querySelector('[data-collection-root]');
  if(!root) return;

  var sectionId = root.getAttribute('data-section-id');
  var gridSel   = '[data-collection-results]';
  var busy = false;
  var pending = null;   // viimeisin busy-aikana pyydetty [url, push] (live-haku)

  /* ---------- Näkymän vaihto (lista / grid) ---------- */
  var VIEW_KEY = 'skelte:collection-view';
  function getSavedView(){
    try { return localStorage.getItem(VIEW_KEY); } catch(e){ return null; }
  }
  function saveView(v){
    try { localStorage.setItem(VIEW_KEY, v); } catch(e){}
  }
  function applyView(v){
    var grid = root.querySelector('[data-product-grid]');
    if(grid){
      grid.setAttribute('data-view', v);
      grid.classList.remove('pgrid--list','pgrid--grid');
      grid.classList.add('pgrid--' + v);
    }
    var btns = root.querySelectorAll('[data-view-set]');
    btns.forEach(function(b){
      b.setAttribute('aria-pressed', b.getAttribute('data-view-set') === v ? 'true' : 'false');
    });
  }
  function initView(){
    var saved = getSavedView();
    if(saved === 'list' || saved === 'grid'){ applyView(saved); }
    // muuten jätetään serverin renderöimä oletus (data-view jo paikallaan)
  }

  /* ---------- Osittainen päivitys ---------- */
  // Sisääntuloanimaatio: lisää .pgrid--reveal → CSS hoitaa porrastetun fade-in-upin.
  // Reflow-pakotus varmistaa että animaatio käynnistyy uudelleen swapin jälkeen.
  function revealGrid(){
    var grid = root.querySelector('[data-product-grid]');
    if(!grid) return;
    grid.classList.remove('pgrid--reveal');
    void grid.offsetWidth;
    grid.classList.add('pgrid--reveal');
  }

  function runPending(){
    if(!pending) return;
    var p = pending; pending = null;
    fetchAndSwap(p[0], p[1]);
  }

  function fetchAndSwap(url, push){
    if(busy){ pending = [url, push]; return; }
    busy = true;
    var results = root.querySelector(gridSel);
    if(results) results.setAttribute('aria-busy', 'true');

    var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);

    fetch(fetchUrl)
      .then(function(r){ if(!r.ok) throw new Error('bad'); return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // [data-search-layout] + [data-search-term] vain hakusivulla (muualla ohitetaan)
        var swaps = ['[data-search-layout]','[data-search-term]','[data-collection-results]','[data-desktop-filters]','[data-active-filters]','[data-collection-count]','[data-drawer-filters]'];
        swaps.forEach(function(sel){
          // desktop-filtterit ja drawer-filtterit ovat eri paikoissa; hae molemmat dokista+sivulta
          var oldEls = document.querySelectorAll(sel);
          var newEl = doc.querySelector(sel);
          if(newEl){
            oldEls.forEach(function(oldEl){ oldEl.innerHTML = newEl.innerHTML; });
          }
        });
        if(push){ history.pushState({ skelteCollection:true }, '', url); }
        var res = root.querySelector(gridSel);
        if(res) res.removeAttribute('aria-busy');
        // grid vaihtui → palauta valittu näkymä
        initView();
        revealGrid();
        document.dispatchEvent(new CustomEvent('skelte:filters-swapped'));
        // uudet hinnat DOM:issa → palauta valittu ALV-näkymä
        if(window.VAT && window.VAT.applyAll){ window.VAT.applyAll(res || document); }
        busy = false;
        if(pending){ runPending(); return; }
        var top = root.getBoundingClientRect().top;
        if(top < -80) root.scrollIntoView({ behavior:'smooth', block:'start' });
      })
      .catch(function(){
        busy = false;
        if(pending){ runPending(); return; }
        window.location.href = url;   // fallback: kova navigointi
      });
  }

  // Julkinen rajapinta (hakusivun live-kenttä kutsuu tätä)
  window.SkelteCollection = { load: fetchAndSwap };

  /* ---------- Lomake → URL ---------- */
  function formToUrl(form){
    var params = new URLSearchParams(new FormData(form));
    var cleaned = new URLSearchParams();
    params.forEach(function(v, k){ if(v !== '' && v != null) cleaned.append(k, v); });
    var base = form.getAttribute('action') || window.location.pathname;
    var qs = cleaned.toString();
    return base + (qs ? '?' + qs : '');
  }

  /* ===== DELEGAATIO (document-taso — kattaa sekä sivupalkin että drawerin) ===== */

  // checkbox/radio muutos → heti AJAX
  document.addEventListener('change', function(e){
    var t = e.target;
    if(t && t.matches && t.matches('[data-filter-input]')){
      var form = t.closest('[data-filter-form]');
      if(form){ fetchAndSwap(formToUrl(form), true); }
    }
  });

  /* Kun desktop-ryhmä avataan, vieritä se kokonaan suodatinalueelle jos
     mahdollista. Sisältö on normaalissa virtauksessa, joten mikään arvo ei
     jää absoluuttisen popoverin ja overflow-rajan väliin. */
  document.addEventListener('toggle', function(e){
    var details = e.target;
    if(!details || !details.matches || !details.matches('.cfilter--dropdown') || !details.open) return;

    window.requestAnimationFrame(function(){
      var scroller = details.closest('[data-filters-scroll]');
      if(!scroller) return;

      var detailRect = details.getBoundingClientRect();
      var scrollRect = scroller.getBoundingClientRect();
      var delta = 0;

      if(detailRect.height >= scrollRect.height){
        delta = detailRect.top - scrollRect.top;
      } else if(detailRect.bottom > scrollRect.bottom){
        delta = detailRect.bottom - scrollRect.bottom + 4;
      } else if(detailRect.top < scrollRect.top){
        delta = detailRect.top - scrollRect.top - 4;
      }

      if(delta){ scroller.scrollBy({ top: delta, behavior: 'smooth' }); }
      updateFade(scroller);
    });
  }, true);

  // lomakkeen submit (hintakenttä Enter TAI Käytä-nappi) → AJAX, ei reloadia
  document.addEventListener('submit', function(e){
    var form = e.target;
    if(form && form.matches && form.matches('[data-filter-form]')){
      e.preventDefault();
      fetchAndSwap(formToUrl(form), true);
    }
  });

  // Enter hintakentässä: varmista ettei natiivi submit pääse läpi ennen käsittelyä
  document.addEventListener('keydown', function(e){
    if(e.key === 'Enter'){
      var t = e.target;
      if(t && t.matches && t.matches('[data-price-input]')){
        e.preventDefault();
        var form = t.closest('[data-filter-form]');
        if(form){ fetchAndSwap(formToUrl(form), true); }
      }
    }
  });

  // klikkaukset: aktiivisten X-linkit, Tyhjennä, drawer auki/kiinni
  document.addEventListener('click', function(e){
    // Dropdown-popoverit: sulje muut kun avataan yksi / klikataan ulkopuolelle
    var sum = e.target.closest ? e.target.closest('.cfilter--dropdown > .cfilter__summary') : null;
    var insidePopover = e.target.closest ? e.target.closest('.cfilter__popover') : null;
    if(sum || !insidePopover){
      var openDropdowns = document.querySelectorAll('.cfilter--dropdown[open]');
      openDropdowns.forEach(function(d){
        // Älä sulje sitä jonka summarya juuri klikattiin (natiivi toggle hoitaa sen)
        if(sum && d.contains(sum)) return;
        d.removeAttribute('open');
      });
    }

    // Sivupalkin SEO: Lue lisää / Näytä vähemmän
    var seoToggle = e.target.closest ? e.target.closest('[data-seo-toggle]') : null;
    if(seoToggle){
      var seoBox = seoToggle.closest('[data-sidebar-seo]');
      if(seoBox){
        var open = seoBox.classList.toggle('is-open');
        seoToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }

    // AJAX-linkit (aktiiviset filtterit, tyhjennä kaikki)
    var rm = e.target.closest ? e.target.closest('[data-filter-remove]') : null;
    if(rm){
      e.preventDefault();
      fetchAndSwap(rm.getAttribute('href'), true);
      return;
    }
    // Shopifyn muodostama suodatinlinkki (lisää tai poistaa yhden arvon)
    var filterLink = e.target.closest ? e.target.closest('[data-filter-link]') : null;
    if(filterLink){
      e.preventDefault();
      fetchAndSwap(filterLink.getAttribute('href'), true);
      return;
    }
    // drawer auki
    var openBtn = e.target.closest ? e.target.closest('[data-cf-open]') : null;
    if(openBtn){ openDrawer(); return; }
    // drawer kiinni
    var closeBtn = e.target.closest ? e.target.closest('[data-cf-close]') : null;
    if(closeBtn){ closeDrawer(); return; }
    // Lataa lisää
    var more = e.target.closest ? e.target.closest('[data-load-more]') : null;
    if(more){ e.preventDefault(); loadMore(more); return; }
    // näkymän vaihto
    var vb = e.target.closest ? e.target.closest('[data-view-set]') : null;
    if(vb){
      var v = vb.getAttribute('data-view-set');
      applyView(v);
      saveView(v);
      return;
    }
  });

  // lajittelu (delegoitu change kattaa senkin, mutta erillinen koska muuttaa sort_by:n)
  document.addEventListener('change', function(e){
    var sel = e.target;
    if(sel && sel.matches && sel.matches('[data-sort-select]')){
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      fetchAndSwap(u.pathname + u.search, true);
    }
  });

  /* ---------- Drawer ---------- */
  function drawerEl(){ return document.querySelector('[data-cf-drawer]'); }
  function openDrawer(){
    var d = drawerEl(); if(!d) return;
    d.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    d.setAttribute('aria-hidden','false');
  }
  function closeDrawer(){
    var d = drawerEl(); if(!d) return;
    d.classList.remove('is-open');
    document.body.style.overflow = '';
    d.setAttribute('aria-hidden','true');
  }
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){
      var d = document.querySelector('[data-cf-drawer].is-open');
      if(d) closeDrawer();
    }
  });

  /* ---------- Lataa lisää ---------- */
  function loadMore(btn){
    var grid = root.querySelector('[data-product-grid]');
    if(!grid) return;
    var url = btn.getAttribute('data-next-url');
    if(!url || btn.disabled) return;
    var LOADING = btn.getAttribute('data-loading') || 'Ladataan…';
    var LABEL = btn.textContent.trim();
    btn.disabled = true; btn.textContent = LOADING;
    fetch(url)
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html,'text/html');
        doc.querySelectorAll('[data-product-grid] > li').forEach(function(li){ grid.appendChild(li); });
        // uudet kortit → ALV-näkymä + valittu näkymätila
        if(window.VAT && window.VAT.applyAll){ window.VAT.applyAll(grid); }
        var nb = doc.querySelector('[data-load-more]');
        if(nb){ btn.setAttribute('data-next-url', nb.getAttribute('data-next-url')); btn.disabled=false; btn.textContent=LABEL; }
        else if(btn.parentNode){ btn.parentNode.removeChild(btn); }
      })
      .catch(function(){ btn.disabled=false; btn.textContent=LABEL; });
  }

  // Back/forward
  window.addEventListener('popstate', function(){
    fetchAndSwap(window.location.pathname + window.location.search, false);
  });

  // Alusta näkymä (localStorage-muisti)
  initView();
  revealGrid();

  /* ---------- Scroll-häivytysreunat (filtterit + SEO) ----------
     Lisää .has-top / .has-bottom sen mukaan onko ylä-/alapuolella scrollattavaa.
     → CSS näyttää pehmeän faden vain kun sisältöä on piilossa. */
  function updateFade(el){
    if(!el) return;
    var scrollable = el.scrollHeight - el.clientHeight;
    if(scrollable <= 2){
      el.classList.remove('has-top','has-bottom');
      return;
    }
    el.classList.toggle('has-top', el.scrollTop > 2);
    el.classList.toggle('has-bottom', el.scrollTop < scrollable - 2);
  }
  function bindFade(el){
    if(!el || el.dataset.fadeBound) return;
    el.dataset.fadeBound = '1';
    el.addEventListener('scroll', function(){ updateFade(el); }, { passive:true });
    updateFade(el);
  }

  // Filtterien scrollausalue (voi vaihtua AJAXissa → sido tarvittaessa uudelleen)
  function bindFilterFade(){
    var sc = root.querySelector('[data-filters-scroll]');
    if(sc){ bindFade(sc); updateFade(sc); }
  }
  bindFilterFade();

  // SEO-teksti: kiinni-tila päättää tarvitaanko "Lue lisää"; auki-tila saa scroll-faden.
  // Useita laatikoita (desktop-sivupalkki + mobiili grid-alaosa) → käsittele kaikki.
  var seoBoxes = document.querySelectorAll('[data-sidebar-seo]');
  seoBoxes.forEach(function(seoBox){
    var seoBody = seoBox.querySelector('[data-seo-body]');
    if(!seoBody) return;
    var seoToggleBtn = seoBox.querySelector('[data-seo-toggle]');
    // Mahtuuko teksti ilman häivytystä → toggle pois
    if(seoToggleBtn && seoBody.scrollHeight <= seoBody.clientHeight + 4){
      seoToggleBtn.style.display = 'none';
      seoBody.style.webkitMaskImage = 'none';
      seoBody.style.maskImage = 'none';
    }
    // Auki-tilan scroll-fade
    bindFade(seoBody);
    var mo = new MutationObserver(function(){ updateFade(seoBody); });
    mo.observe(seoBox, { attributes:true, attributeFilter:['class'] });
  });

  // Uudelleenlaske reunat ikkunan koon muuttuessa
  window.addEventListener('resize', function(){
    bindFilterFade();
    seoBoxes.forEach(function(b){
      var body = b.querySelector('[data-seo-body]');
      if(body) updateFade(body);
    });
  });

  // AJAX-swap uusii filtterien DOMin → sido fade uudelleen
  document.addEventListener('skelte:filters-swapped', bindFilterFade);
})();
